var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Radio',_vm._b({scopedSlots:_vm._u([{key:"icon",fn:function(props){return [_c('v-icon',{style:({
          '--size': _vm.size
        }),attrs:{"name":props.checked ? 'selected' : 'unselected'}})]}}]),model:{value:(_vm.initialValue),callback:function ($$v) {_vm.initialValue=$$v},expression:"initialValue"}},'Radio',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }